import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Divider, Stack} from '@mui/material';
import {get} from 'lodash';
import {FC} from 'react';
import {DateHelpers} from '../../../../shared/helpers/dateHelpers';
import {ContractFieldProps} from '../../types/balance-replenishment.types';
import {
  CompanyTitle,
  ContractCheckbox,
  ContractContainer,
  ContractHeader,
  FieldContainer,
  RequisitesAccordion,
  RequisitesDetails,
  RequisitesSummary,
  SectionTitle,
  SubText,
  Text,
} from './styles';

export const ContractField: FC<ContractFieldProps> = ({data, selectedContractId, onSelectContract, hasError}) => {
  const innerContracts = data?.innerContracts || [];

  return (
    <FieldContainer>
      <ContractHeader>
        <SectionTitle>Выберите договор</SectionTitle>
      </ContractHeader>
      <ContractContainer hasError={hasError}>
        <Stack px={2} py={1.5} gap={0.25}>
          <CompanyTitle>{data?.fullCompanyName}</CompanyTitle>

          <RequisitesAccordion>
            <RequisitesSummary expandIcon={<ExpandMoreIcon fontSize="small" />}>Реквизиты</RequisitesSummary>
            <RequisitesDetails>
              <Text>ИНН: {data?.inn}</Text>
              <Text>ОГРН: {data?.ogrn}</Text>
              <Text>КПП: {get(data, 'kpp')}</Text>
              <Text>Расчетный счет: {get(data, 'payment.rs')}</Text>
              <Text>Наименование банка: {get(data, 'payment.bankName')}</Text>
              <Text>Бик: {get(data, 'payment.bik')}</Text>
              <Text>Корреспондентский счет: {get(data, 'payment.cor')}</Text>
              <Text>Юридический адрес: {get(data, 'address.fullAddress')}</Text>
              <Text>ФИО руководителя: {get(data, 'leaderFIO')}</Text>
            </RequisitesDetails>
          </RequisitesAccordion>
        </Stack>
        <Divider />
        <Stack px={2} py={1.5} gap={1.25}>
          {!innerContracts.length ? (
            <Text>Контракты отсутствуют</Text>
          ) : (
            (data?.innerContracts || []).map((c, index) => {
              const contractKey = c.id || c.innerNumber || String(index);
              return (
                <Stack key={contractKey} direction="row" gap={1.5} alignItems="flex-start">
                  <ContractCheckbox
                    checked={selectedContractId === contractKey}
                    onChange={() => onSelectContract(contractKey)}
                  />
                  <Stack>
                    <Text>
                      Договор № {c.innerNumber} от {DateHelpers.formatToRu(c.startDate).split(',')[0]}
                    </Text>
                    <SubText>Срок действия договора: {DateHelpers.formatToRu(c.endDate).split(',')[0]}</SubText>
                  </Stack>
                </Stack>
              );
            })
          )}
        </Stack>
      </ContractContainer>
    </FieldContainer>
  );
};
